/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_One_FrameInputs */



/**
* | output |
* | --- |
* | "Forward 1 Frame" |
*
* @param {Shortcut_Keys_Name_Forward_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_one_frame = /** @type {((inputs?: Shortcut_Keys_Name_Forward_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer de 1 image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorwärts 1 Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanti 1 fotogramma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вперед 1 кадр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar 1 fotograma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向前 1 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1フレーム進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1 फ्रेम आगे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avançar 1 quadro")
	return /** @type {LocalizedString} */ ("Forward 1 Frame")
});